Object.defineProperty(exports, '__esModule', { value: true });

var SIZE_TO_CLASSNAME_MAP = {
    s: 'size-500',
    500: 'size-500',
};

exports.SIZE_TO_CLASSNAME_MAP = SIZE_TO_CLASSNAME_MAP;
